import React, { useMemo } from 'react';
import { useLocale } from '../contexts/LocaleContext';
import { LegalDocument } from './LegalDocument';
import { legalDocumentForLocale } from '../utils/legal-documents';

import termsEn from '../content/terms-of-service-en.md?raw';
import termsEs from '../content/terms-of-service-es.md?raw';
import termsFr from '../content/terms-of-service-fr.md?raw';
import termsDe from '../content/terms-of-service-de.md?raw';
import termsCa from '../content/terms-of-service-ca.md?raw';

export const TermsOfService: React.FC = () => {
  const { locale } = useLocale();
  const content = useMemo(
    () =>
      legalDocumentForLocale(locale, {
        en: termsEn,
        es: termsEs,
        fr: termsFr,
        de: termsDe,
        ca: termsCa,
      }),
    [locale],
  );

  return <LegalDocument content={content} />;
};
